import clsx from 'clsx';

import { FadeIn } from '../FadeIn';

interface ISectionHeaderProps {
  className?: string;
  /**
   * Amount of time in seconds to delay the animation
   */
  fadeInDelay?: number;
  /**
   * Duration over which to animate the header
   */
  fadeInDuration?: number;
  /**
   * The eyebrow text for the section header.
   */
  text: string;
  /**
   * The initial fade in opacity of the text.
   */
  initOpacity?: number;
  /**
   * The initial fade in y position of the text.
   */
  initX?: number;
  /**
   * The initial fade in x position of the text.
   */
  initY?: number;
}

/**
 * -----------------------------------------------------------------------------
 * This renders a section header with eyebrow and title text.
 */
export function EyebrowText({
  className,
  fadeInDelay = 0,
  fadeInDuration = 0.05,
  initOpacity = 0.5,
  initX = 0,
  initY = 24,
  text,
}: ISectionHeaderProps) {
  return (
    <FadeIn
      className={clsx(
        'text-base uppercase tracking-widest text-green-600 max-lg:text-sm',
        className,
      )}
      delay={fadeInDelay}
      duration={fadeInDuration}
      initOpacity={initOpacity}
      initX={initX}
      initY={initY}
    >
      {text}
    </FadeIn>
  );
}
